<template>
  
  <div>
    <!-- 메뉴 -->
    <nav
      v-show="$store.state.isLogin"
      class="navbar navbar-dark bg-primary"
      id="navsmenu"
    >
      <a
        class="navbar-brand"
        href="#"
        @click.prevent="$router.push('./dashboard')"
        style="font-weight: 600; font-size: 20px;"
      >
        {{ getCodeName(classgetname) }} 만나
      </a>
      
      <span class="navbar-text mr-2" style="color: white; margin-left: auto; font-weight: bold;">
          ♡ {{ $store.state.name }}
      </span>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
     
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <button
              v-show="$store.state.role < 5"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./studentlist')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              학생(아동)목록
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="$store.state.role == 3 || $store.state.role == 1 || $store.state.role == 4"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./attendance')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              분반보고서
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="$store.state.role == 3 || $store.state.role == 1"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./weeklyreport')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              양육보고현황
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="$store.state.role == 3 || $store.state.role == 1"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./attendtotal')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              출결집계
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="($store.state.role == 3 || $store.state.role == 1) && !['1','2','3','4'].includes($store.state.classid)"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./talenttotal')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              달란트 현황
            </button>
          </li>
          <li class="nav-item">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./attendallcount')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              전체출결
            </button>
          </li>
          <li class="nav-item">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./notice')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              공지사항
            </button>
          </li>
          <li class="nav-item">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./study')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              분반자료
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="$store.state.role < 2"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./reports')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              분반보고현황
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="$store.state.role == 1 || $store.state.role == 3"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./personreport')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              학생(아동)별보고서
            </button>
          </li>
          <li class="nav-item">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./pray')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              중보기도수첩
            </button>
          </li>           
          <li class="nav-item">
            <button
            v-show="$store.state.role == 1 || $store.state.role == 4"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./teachermgmt')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              교사등록관리
            </button>
          </li>             
          <!-- <li class="nav-item">
            <button
              v-show="$store.state.role < 2"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 120px; font-size: 1em; font-weight: 500"
              @click="this.$router.push('./newsletter')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              주보등록
            </button>
          </li>           -->
          <li class="nav-item">
            <button
              v-show="$store.state.isLogin"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 200px; font-size: 1em; font-weight: 500;text-align: left;"
              @click="this.$router.push('./logout')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              로그아웃
            </button>
          </li>

          <!-- <li class="nav-item">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 100px; font-size: 1em; font-weight: 500"
              @click="this.$router.push('./membergoout')"
              data-toggle="collapse"
              data-target="#navbarText"
            >
              회원탈퇴
            </button>
          </li> -->
        </ul>
      </div>
    </nav>
    <!-- 메뉴 -->

    <div class="container mt-3">
      <router-view />
    </div>

    <!-- 하단 탭 바 -->
    <div v-show="$store.state.isLogin" class="tab-bar">
      <router-link to="/dashboard" class="tab-item" :class="{ 'active': $route.path === '/dashboard' }">
        <i class="bi bi-house-door-fill"></i>
        <p>홈</p>
      </router-link>
      <router-link to="/attendance" class="tab-item" :class="{ 'active': $route.path === '/attendance' }">
        <i class="bi bi-journal-text"></i>
        <p>보고서(출석)</p>
      </router-link>
      <router-link to="/studentlist" class="tab-item" :class="{ 'active': $route.path === '/studentlist' }">
        <i class="bi bi-people-fill"></i>
        <p>학생(아동)</p>
      </router-link>
      <router-link to="/attendallcount" class="tab-item" :class="{ 'active': $route.path === '/attendallcount' }">
        <i class="bi bi-calendar-check"></i>
        <p>출석현황</p>
      </router-link>
    </div>
  </div>
</template>

<script>

 import { mapGetters } from 'vuex';
 import { initInstallPrompt, triggerInstallPrompt } from './installPromptHandler';
 import 'bootstrap-icons/font/bootstrap-icons.css';
 //import { getCodeName } from './store/codes'; // 헬퍼 함수를 유틸리티로 분리한 경우

  export default {
    name: "app",
    data() {
      return {
        // id: this.$store.getters.doneId,
        // grade: this.$store.getters.doGrade,
        // phone: this.$store.getters.doPhone,
        // name: this.$store.getters.doneName,
        // teacherid: this.$store.getters.doTecherid,
        // role: this.$store.getters.doRole,
        // token: this.$store.getters.doToken,
        id: this.$store.state.id,
        grade: this.$store.state.grade,
        phone: this.$store.state.phone,
        name: this.$store.state.name,
        teacherid: this.$store.state.teacherid,
        role: this.$store.state.role,
        token: this.$store.state.token,
        classid: this.$store.state.classid ? this.$store.state.classid : this.$cookies.get("classid"),
        isLogin: false,
        classgetname : "",
        showInstallButton: false,
      };
    },

    mounted(){

        try {
          this.initLogin();
        } catch (error) {
          console.error('created 훅 오류:', error);
        }

        initInstallPrompt((showButton) => {
        this.showInstallButton = showButton;
        });        
    },
    created() {     

      try {
          this.initLogin();
        } catch (error) {
          console.error('created 훅 오류:', error);
        }      

      const userData = localStorage.getItem('userData');
      if (userData) {
        this.id =  userData.id;
        this.grade =  userData.grade;
        this.phone = userData.phone;
        this.name =  userData.name;
        this.teacherid =  userData.teacherid;
        this.role = userData.role;
        this.token =  userData.token;
        this.classid = userData.classid;
      }   

      this.classgetname = this.$store.state.classid;

      console.log("this.phone" ,  this.phone);
      
      console.log('Initial classid:', this.classid);
      console.log('Store classid:', this.$store.state.classid);

      // console.log(this.teacherid, this.role);
      // const userData = localStorage.getItem('userData');
      // if (userData) {
      //   this.$store.state.isAuthenticated = true;
      //   this.$store.dispatch('login', JSON.parse(userData));
      //   //commit('setLoginState', JSON.parse(userData));
      // }      
      //   this.$store.dispatch('setLoginState');
    },
    computed: {
    ...mapGetters('codes', ['getCodeName']), // Vuex 모듈 'codes'의 getter 등록
    isAuthenticated() {

      let isLocalAuthenticated = false;
      const userData = localStorage.getItem('userData');
      isLocalAuthenticated = this.$store.state.isAuthenticated;
      if (userData) {
        isLocalAuthenticated = true;
      }      
      console.log("isAuthenticated == ", isLocalAuthenticated);
      return isLocalAuthenticated;
    }
  },
  methods: {

  initLogin(){
    // localStorage에서 로그인 상태를 가져옵니다.
    const isLogin = JSON.parse(localStorage.getItem("userData"));
    //console.log("this.isLogin" ,  isLogin.id);
    // localStorage에 로그인 상태가 저장되어 있으면 이를 사용합니다.
    if (isLogin !== null && isLogin.id) {
      this.$store.state.isLogin = true;
      this.$store.state.id =  isLogin.id;
      this.$store.state.grade =  isLogin.grade;
      this.$store.state.phone = isLogin.phone;
      this.$store.state.name =  isLogin.name;
      this.$store.state.teacherid =  isLogin.teacherid;
      this.$store.state.role = isLogin.role;
      this.$store.state.token =  isLogin.token;
      this.$store.state.classid = isLogin.classid;
    } else {
      this.$store.state.isLogin = false;
      this.$store.state.name = "";
      this.$store.state.role = "";
      this.$store.state.grade = "";
    }
  },
  logout() {

    localStorage.removeItem("id");
    localStorage.removeItem("grade");
    localStorage.removeItem("phone");
    localStorage.removeItem("name");
    localStorage.removeItem("teacherid");
    localStorage.removeItem("role");
    localStorage.removeItem("classid");      
    localStorage.removeItem("isLogin"); 
    localStorage.removeItem("userData");
    localStorage.clear();

    this.$store.dispatch('logout');
    this.$cookies.remove("phone");
    this.$cookies.remove("classid");
    this.$store.commit("logout");
    this.$store.commit('setLogoutState');
    
    localStorage.setItem("isLogin", "false");
    this.$store.state.isLogin = false;

    this.$router.push({ path: "/login" });
           
  },
  async promptInstall() {
      const success = await triggerInstallPrompt();
      if (success) {
        console.log('App installed successfully');
      } else {
        console.log('User dismissed the install prompt');
      }
      this.showInstallButton = false;
    },  
}    
  };
</script>
<style>
  body {
    font-family: "Noto Sans KR", "Helvetica Neue", sans-serif;
  }
  a {
    color: #369;
    text-decoration: none;
  }

  /* 하단 탭바 스타일 */
  .tab-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    padding: 8px 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
    text-decoration: none;
    width: 25%;
  }

  .tab-item i {
    font-size: 24px;
    margin-bottom: 4px;
  }

  .tab-item p {
    margin: 0;
    font-size: 12px;
    text-align: center;
  }

  .tab-item.active {
    color: #007bff;
  }

  /* 탭바로 인한 컨텐츠 하단 여백 */
  .container {
    padding-bottom: 70px;
  }
</style>

<!-- 
          <li class="nav-item">
            <button
              v-show="userInfo"
              type="button"
              class="btn btn-primary btn-sm"
              style="
                width: 200px;
                font-size: 1em;
                font-weight: 500;
                text-align: left;
              "
              @click="this.$router.push('./exceldownload_dept')"
            >
            자료 다운로드
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="userInfo && grade > 1"
              type="button"
              class="btn btn-primary btn-sm"
              style="
                width: 200px;
                font-size: 1em;
                font-weight: 500;
                text-align: left;
              "
              @click="this.$router.push('./exceldownload')"
            >
              Excel Download(PMO)
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="userInfo && grade == 3"
              type="button"
              class="btn btn-primary btn-sm"
              style="
                width: 200px;
                font-size: 1em;
                font-weight: 500;
                text-align: left;
              "
              @click="this.$router.push('./sample')"
            >
              Sample
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="userInfo"
              type="button"
              class="btn btn-primary btn-sm"
              style="
                width: 200px;
                font-size: 1em;
                font-weight: 500;
                text-align: left;
              "
              @click="this.$router.push('./chart')"
            >
              통계
            </button>
          </li>
          <li class="nav-item">
            <button
              v-show="isLogin"
              type="button"
              class="btn btn-primary btn-sm"
              style="width: 80px; font-size: 1em; font-weight: 500"
              @click="this.$store.dispatch('logout')"
            >
              Logout
            </button>
          </li>-->
